import Location from "@components/Location/index";
import Session from "@lib/session";
import useConfig from "@lib/use_config";
import useContent from "@lib/use_content";
import { Place } from "@universal/internal/Place";
import { findLocations } from "@universal/services/find_locations";
import locationPredictionSelected from "@universal/services/location_prediction_selected";

export default function LocationField({
  className = "",
  focusOnMount,
  submitting,
}: {
  className?: string;
  focusOnMount: boolean;
  submitting: boolean;
}): JSX.Element {
  const { data, error, loading } = useContent([
    "beErrFieldRequired",
    "beProfileLocationsFieldLabel",
  ]);
  const { data: cfgData, loading: cfgLoading } = useConfig(["universalLocationsMode"]);

  let findLocationsFn, locPredictionRenderer, locPredictionSelectedFn;
  if (cfgData?.config.universalLocationsMode) {
    findLocationsFn = findLocations;
    locPredictionRenderer = Place;
    locPredictionSelectedFn = locationPredictionSelected;
  }

  return loading && cfgLoading ? null : (
    <div className={className}>
      <Location
        className="max-w-[605px]"
        disabled={submitting}
        fieldName={`location`}
        findLocations={findLocationsFn}
        locationPredictionRenderer={locPredictionRenderer}
        locationPredictionSelected={locPredictionSelectedFn}
        placeholder={data?.content.beProfileLocationsFieldLabel}
        serviceAreaFilter={Session.getConfig().serviceArea}
        focusOnMount={focusOnMount}
        hidePuds
        noAutosizing
      />
    </div>
  );
}
